import React, { useEffect, useInsertionEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import { router } from '@/app/router'
import { GlobalProvider } from '@/entities'
import { tenantConfig } from '@/shared/config/tenant'

function App() {
    useEffect(()=>{
        if(tenantConfig.name?.title){
            document.title = tenantConfig.name.title
        }
        if(tenantConfig.favicon_url){
            const link = document.createElement('link')
            link.rel = 'icon'
            link.href = tenantConfig.favicon_url
            document.head.appendChild(link)
        }
    },[])

    useInsertionEffect(() => {
        document.documentElement.style.setProperty('--clr-primary', tenantConfig?.color?.light?.primary || '#40c067')
    }, [])

    return (
        <GlobalProvider>
            <RouterProvider router={router} />
        </GlobalProvider>
    )
}

export default App
